import { DataSource, HorizontalSpacer, Layout, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiLocationsList extends Layout {
    horizontalspacer2: HorizontalSpacer;
    panelSearch: Panel;
    searchpanelLocations: SearchPanel;
    sourceEdilocation: DataSource;
    tableEdiLocations: Table;
    textboxEdiLocation: Textbox;
    textboxLocationId: Textbox;
    textboxLocationType: Textbox;
    textboxPartnerId: Textbox;
}
